import { TextInput } from '@mantine/core'
import { IconSearch, IconX } from '@tabler/icons-react'

export const FilterInput = ({
  filter,
  onFilter,
  placeholder = '',
  collapsing = true,
  onClear,
  size = 'md'
}: {
  filter: string
  placeholder?: string
  onFilter: (filter: string) => void
  collapsing?: boolean
  width?: string
  onClear?: () => void
  key?: string
  size?: string
}) => {
  return (
    <TextInput
      variant={'transparent'}
      styles={{ input: { color: 'var(--sc-shell-fg)' } }}
      size={size || 'md'}
      placeholder={placeholder}
      classNames={{
        input: `${filter ? 'w-48 ' : collapsing && ' w-[50px]'} transition-all border-1 border-transparent  
          hover:border-sky-400 hover:w-48
          focus:border-sky-200 focus:w-48`
      }}
      leftSectionPointerEvents="none"
      leftSection={<IconSearch color={'var(--sc-shell-fg)'} />}
      rightSection={
        filter && (
          <IconX
            onClick={() => {
              onFilter('')
              onClear && onClear()
            }}
            color={'var(--sc-shell-fg)'}
          />
        )
      }
      value={filter}
      onKeyDown={(e) => e.key === 'Escape' && onFilter('')}
      onChange={(e) => {
        onFilter(e.target.value)
      }}
    />
  )
}
